import React from 'react';
import type { SinonSandbox, SinonSpy, SinonStub } from 'sinon';
import { stub } from 'sinon';

import { NewAnalyticsContext } from './new-analytics-context';

interface MockAnalyticsClient {
  sendUIEvent: SinonSpy;
  sendTrackEvent: SinonSpy;
  sendScreenEvent: SinonSpy;
  sendOperationalEvent: SinonSpy;
  init: SinonSpy;
  initOriginTracingHandlers: SinonSpy;
  setOrgId: SinonSpy;
  getAnalyticsWebClient: SinonSpy;

  reset(): void;
}

export const getReturnStub = (callback: (args: any) => any, sandboxInstance?: SinonSandbox) => {
  if (sandboxInstance) {
    try {
      return sandboxInstance.stub(React, 'useContext').callsFake(callback);
    } catch {
      (React.useContext as any).restore();

      return sandboxInstance.stub(React, 'useContext').callsFake(callback);
    }
  }

  try {
    return stub(React, 'useContext').callsFake(callback);
  } catch {
    (React.useContext as any).restore();

    return stub(React, 'useContext').callsFake(callback);
  }
};

export const stubUseAnalyticsContext = (client: MockAnalyticsClient, sandboxInstance?: SinonSandbox): SinonStub => {
  const realUseContext = React.useContext;

  const callback = (args: any) => {
    if (args === NewAnalyticsContext) {
      return client;
    }

    return realUseContext(args);
  };

  return getReturnStub(callback, sandboxInstance);
};
